import {useEffect, useRef} from "react";
import {useQuery, useQueryClient} from "@tanstack/react-query";
import { BACKEND } from "../config/backend";
import axios from "axios";

export const APP_VERSION = process.env.REACT_APP_VERSION
const BACKEND_VERSION_STALE_TIME = 5 * 60 * 1000;
const BACKEND_VERSION_GC_TIME = 10 * 60 * 1000;

const getBackendVersion = async (signal) => {
    const response = await axios.get(`${BACKEND}/api/v1/system/app-compatibility`, {
        signal
    });
    return response.data;
};

const isBackendNewer = (frontendVersion, backendVersion) => {
    if (!frontendVersion || !backendVersion) {
        return false;
    }

    const frontendParts = frontendVersion.split('.').map(Number);
    const backendParts = backendVersion.split('.').map(Number);
    
    for (let i = 0; i < 2; i++) {
        if (backendParts[i] > frontendParts[i]) return true;
        if (backendParts[i] < frontendParts[i]) return false;
    }
    return false;
};

export const useBackendVersionSync = () => {
    const queryClient = useQueryClient();
    const lastCheckedVersionRef = useRef(null);
    const reloadScheduledRef = useRef(false);
    
    const { data: backendVersionMap } = useQuery({
        queryKey: ['system', 'backend-version'],
        queryFn: ({ signal }) => getBackendVersion(signal),
        staleTime: BACKEND_VERSION_STALE_TIME,
        gcTime: BACKEND_VERSION_GC_TIME,
        refetchInterval: BACKEND_VERSION_STALE_TIME,
        refetchOnWindowFocus: false,
        refetchOnReconnect: true,
        refetchOnMount: false,
    });

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible' && !reloadScheduledRef.current) {
                queryClient.refetchQueries({
                    queryKey: ['system', 'backend-version'],
                    exact: true,
                });
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
    }, [queryClient]);

    useEffect(() => {
        if (
            backendVersionMap?.main &&
            backendVersionMap.main !== lastCheckedVersionRef.current &&
            !reloadScheduledRef.current &&
            isBackendNewer(APP_VERSION, backendVersionMap.main)
        ) {
            lastCheckedVersionRef.current = backendVersionMap.main;
            reloadScheduledRef.current = true;
            console.log('Backend ist neuer, Seite wird neu geladen');
            window.location.reload();
        }
    }, [backendVersionMap]);
};
